import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrl: './query.component.scss',
})
export class QueryComponent implements OnInit {
  // Tabs view entitlement
  readonly viewQueryBuildTab: string[] = ['app.dcr-portal.query-interface.view'];
  readonly viewQueryHistoryTab: string[] = ['app.dcr-portal.query-history.view'];
  readonly viewActivationChannelTab: string[] = ['app.dcr-portal.activation.view'];
  readonly viewAudienceExportHistoryTab: string[] = ['app.dcr-portal.audience-export-history.view'];

  selectedTabIndex = 0;
  tabindex = 0;
  queryId: string | null = null;

  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    public appService: AppService,
  ) {
    this.queryId = this.route.snapshot.paramMap.get('queryId');
    this.route.queryParams.subscribe((params) => {
      this.selectedTabIndex = Number(params['tabIndex']);
    });
  }

  ngOnInit(): void {
    if (!this.appService.isEngagementActive) {
      this.tabindex = -1;
    } else {
      this.tabindex = 0;
    }
  }

  public createQuery() {
    this.router.navigate(['/query'], {
      queryParams: { tabIndex: this.tabindex },
    });
  }

  public showHistory() {
    this.router.navigate(['/query'], {
      queryParams: { tabIndex: this.tabindex + 1 },
    });
  }

  public showActivationChannelHistory() {
    this.router.navigate(['/query'], {
      queryParams: { tabIndex: this.tabindex + 2 },
    });
  }

  public showExportAudienceHistory() {
    this.router.navigate(['/query'], {
      queryParams: { tabIndex: this.tabindex + 3 },
    });
  }
}
